module.exports = __webpack_public_path__ + "static/media/md-radio-button-on.25108f01.svg";